var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5122 3.19513H1.43902C1.32259 3.19513 1.21092 3.24138 1.12859 3.32372C1.04625 3.40605 1 3.51772 1 3.63415V18.561C1 18.6774 1.04625 18.7891 1.12859 18.8714C1.21092 18.9538 1.32259 19 1.43902 19H13.7317C13.8481 19 13.9598 18.9538 14.0421 18.8714C14.1245 18.7891 14.1707 18.6774 14.1707 18.561V3.63415C14.1707 3.51772 14.1245 3.40605 14.0421 3.32372C13.9598 3.24138 13.8481 3.19513 13.7317 3.19513H10.6585",
    stroke: "#ABABAB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51221 5.39024V3.19512H6.24635C6.25218 3.19512 6.25776 3.19281 6.26188 3.18869C6.26599 3.18458 6.2683 3.17899 6.2683 3.17317V2.31707C6.2683 2.14411 6.30237 1.97285 6.36856 1.81305C6.43475 1.65326 6.53176 1.50806 6.65407 1.38576C6.77637 1.26346 6.92156 1.16645 7.08136 1.10026C7.24115 1.03407 7.41242 1 7.58538 1C7.75834 1 7.92961 1.03407 8.0894 1.10026C8.24919 1.16645 8.39439 1.26346 8.51669 1.38576C8.63899 1.50806 8.73601 1.65326 8.80219 1.81305C8.86838 1.97285 8.90245 2.14411 8.90245 2.31707V3.17317C8.90245 3.18546 8.91211 3.19512 8.9244 3.19512H10.6585V5.39024C10.6585 5.50668 10.6123 5.61835 10.53 5.70068C10.4476 5.78301 10.336 5.82927 10.2195 5.82927H4.95123C4.83479 5.82927 4.72313 5.78301 4.64079 5.70068C4.55846 5.61835 4.51221 5.50668 4.51221 5.39024Z",
    stroke: "#ABABAB",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.cab89e457756e285188b98be00307e08.svg";
export { ForwardRef as ReactComponent };